import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

function Header() {
  const [showDropdown, setShowDropdown] = useState(false);
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="logo" onClick={() => navigate('/')}>
          <img src='/assets/logo.png' alt="WIML Logo" />
        </div>

        <div className="profile-section">
          <button 
            className="profile-button"
            onClick={() => setShowDropdown(!showDropdown)}
          >
              <img 
                src='/assets/profile.webp'
                alt="Profile" 
                className="profile-image"
              />
          </button>

          {showDropdown && (
            <div className="dropdown-menu">
              {currentUser ? (
                <>
                  <button onClick={() => navigate('/profile')} className="dropdown-item">
                    Profile
                  </button>
                  <button onClick={handleLogout} className="dropdown-item">
                    Logout
                  </button>
                  <button onClick={() => navigate('/support')} className="dropdown-item">
                    Support
                  </button>
                  <button onClick={() => navigate('/privacy')} className="dropdown-item">
                    Privacy Policy
                  </button>
                </>
              ) : (
                <>
                  <button onClick={() => navigate('/login')} className="dropdown-item">
                    Login
                  </button>
                  <button onClick={() => navigate('/signup')} className="dropdown-item">
                    Sign Up
                  </button>
                  <button onClick={() => navigate('/support')} className="dropdown-item">
                    Support
                  </button>
                  <button onClick={() => navigate('/privacy')} className="dropdown-item">
                    Privacy Policy
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;